module.exports = {
	"id": "ZW",
	"name": "Zimbabwe",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.025752,
			"12": 0.003219,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.003219,
			"21": 0.006438,
			"22": null,
			"23": null,
			"24": 0.003219,
			"25": 0.009657,
			"26": 0.006438,
			"27": 0.012876,
			"28": 0.006438,
			"29": 0.025752,
			"30": 0.003219,
			"31": 0.019314,
			"32": 0.019314,
			"33": 0.019314,
			"34": 0.03219,
			"35": 0.012876,
			"36": 0.009657,
			"37": 0.009657,
			"38": 0.006438,
			"39": 0.022533,
			"40": 0.041847,
			"41": 0.012876,
			"42": 0.012876,
			"43": 0.251082,
			"44": 0.016095,
			"45": 0.067599,
			"46": 0.025752,
			"47": 0.035409,
			"48": 0.035409,
			"49": 0.405594,
			"50": 0.048285,
			"51": 0.341214,
			"52": 0.312243,
			"53": 9.293253,
			"54": 2.301585,
			"55": 0.054723,
			"56": 0.012876,
			"57": null
		},
		"firefox": {
			"2": 0.003219,
			"3": 0.061161,
			"4": 0.009657,
			"5": 0.003219,
			"6": 0.003219,
			"7": 0.006438,
			"8": 0.012876,
			"9": 0.003219,
			"10": 0.019314,
			"11": 0.045066,
			"12": 0.025752,
			"13": 0.009657,
			"14": 0.083694,
			"15": 0.019314,
			"16": 0.006438,
			"17": 0.006438,
			"18": 0.012876,
			"19": 0.012876,
			"20": 0.019314,
			"21": 0.019314,
			"22": 0.028971,
			"23": 0.006438,
			"24": 0.03219,
			"25": 0.009657,
			"26": 0.012876,
			"27": 0.012876,
			"28": 0.016095,
			"29": 0.028971,
			"30": 0.038628,
			"31": 0.06438,
			"32": 0.012876,
			"33": 0.038628,
			"34": 0.028971,
			"35": 0.025752,
			"36": 0.028971,
			"37": 0.045066,
			"38": 0.086913,
			"39": 0.038628,
			"40": 0.070818,
			"41": 0.051504,
			"42": 0.099789,
			"43": 0.302586,
			"44": 0.19314,
			"45": 0.151293,
			"46": 0.115884,
			"47": 0.86913,
			"48": 0.666333,
			"49": 5.11821,
			"50": 0.798312,
			"51": 0.009657,
			"52": 0.006438,
			"3.5": 0.006438,
			"3.6": 0.041847
		},
		"opera": {
			"9": null,
			"11": 0.003219,
			"12": 0.009657,
			"15": 0.003219,
			"16": 0.003219,
			"17": 0.003219,
			"18": 0.009657,
			"19": 0.003219,
			"20": 0.003219,
			"21": 0.006438,
			"22": 0.003219,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.003219,
			"29": 0.025752,
			"30": 0.003219,
			"31": 0.006438,
			"32": 0.006438,
			"33": 0.012876,
			"34": 0.019314,
			"35": 0.025752,
			"36": 0.051504,
			"37": 0.16095,
			"38": 0.025752,
			"39": 0.077256,
			"40": 1.15884,
			"41": 0.106227,
			"42": 0.006438,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.003219,
			"11.1": null,
			"11.5": 0.009657,
			"11.6": 0.028971,
			"12.1": 0.038628
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.006438,
			"6": null,
			"7": 0.019314,
			"8": 0.03219,
			"9": 0.057942,
			"10": 0.251082,
			"3.1": null,
			"3.2": null,
			"5.1": 0.038628,
			"6.1": 0.006438,
			"7.1": 0.012876,
			"9.1": 0.141636
		},
		"ios_saf": {
			"8": 0,
			"10": 0.639600699417,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.017236498751,
			"8.1-8.4": 0.0318437010824,
			"9.0-9.2": 0.0151914904246,
			"9.3": 0.231767610325
		},
		"android": {
			"3": 0,
			"4": 0.0707607751938,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00884509689922,
			"4.1": 0.255244224806,
			"4.2-4.3": 0.638110562016,
			"4.4": 1.46323174419,
			"4.4.3-4.4.4": 1.4758675969
		},
		"ie": {
			"6": 0.00645413533835,
			"7": 0.00322706766917,
			"8": 0.616369924812,
			"9": 0.254938345865,
			"10": 0.361431578947,
			"11": 2.6171518797,
			"5.5": null
		},
		"op_mob": {
			"0": 3.43053713239,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0952926981219
		},
		"edge": {
			"12": 0.370185,
			"13": 0.389499,
			"14": 0.428127
		},
		"ie_mob": {
			"10": 0.350268169014,
			"11": 1.42609183099
		},
		"bb": {
			"7": 0.0678,
			"10": null
		},
		"samsung": {
			"0": 1.1187
		},
		"and_uc": {
			"0": 4.0002
		},
		"op_mini": {
			"0": 46.2190301695
		},
		"and_chr": {
			"0": 6.362037
		},
		"and_ff": {
			"0": 0.02034
		}
	},
	"total": 98.3382249323
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/ZW.json
 ** module id = 688
 ** module chunks = 0
 **/